module.exports = __webpack_public_path__ + "img/20240411-160316.35d7bea1.png";